import {
    AnnualReport,
    ConnectPlus,
    LiveSessionView,
    LiveTrack,
    Messaging,
    ProfileImageFrame,
    SocialImprovements,
    Trails,
    AdvancedReporting,
    activationDate,
    autoRenew,
    billingInterval,
    billingIssue,
    contractTerm,
    customerSubscriptions,
    expirationDate,
    isActive,
    isTrial,
    nextBillingDate,
    premiumFeatures,
    promoEndDate
} from './subscriptionFields';

const mockSubscriptions = {
    [customerSubscriptions]: [
        {
            partNumber: '010-D2234-SU',
            [isTrial]: false,
            [isActive]: true,
            source: 'Unknown',
            [expirationDate]: '2025-04-24T11:11:11.6330000Z',
            [activationDate]: '2024-04-24T11:11:42.0799967Z',
            packageInstanceId: 'dev-a565794e-bd69-45ce-8d50-561e843d6a1b',
            foreignSystemId: '',
            foreignSystemSku: '',
            groupCode: [ConnectPlus],
            [premiumFeatures]: [
                {
                    code: LiveSessionView
                },
                {
                    code: Messaging
                },
                {
                    code: LiveTrack
                },
                {
                    code: Trails
                },
                {
                    code: ConnectPlus
                },
                {
                    code: ProfileImageFrame
                },
                {
                    code: AnnualReport
                },
                {
                    code: SocialImprovements
                },
                {
                    code: AdvancedReporting
                }
            ],
            platform: 'GarminMock',
            metaPackageSku: 'GC_META_P',
            [billingInterval]: 'Month',
            [contractTerm]: 'None',
            [billingIssue]: false,
            [autoRenew]: false,
            [nextBillingDate]: '2025-04-24T11:11:11.6330000Z',
            [promoEndDate]: null
        },
        {
            partNumber: 'WRSLTE_ANNUAL_P',
            [isTrial]: false,
            [isActive]: true,
            source: 'EngageIp',
            [expirationDate]: '2024-07-27T00:00:00.0000000Z',
            [activationDate]: '2023-10-27T00:00:00.0000000Z',
            packageInstanceId: '9aa03084-4c23-4ce8-bbfb-c1bfb76f3b11',
            foreignSystemId: '590839',
            foreignSystemSku: 'WRSLTE_ANNUAL_P',
            groupCode: 'Unknown',
            [premiumFeatures]: [],
            platform: 'GarminUac',
            metaPackageSku: 'UNK',
            [billingInterval]: 'Month',
            [contractTerm]: 'None',
            [billingIssue]: false,
            [autoRenew]: true,
            [nextBillingDate]: '2024-07-27T00:00:00.0000000Z',
            [promoEndDate]: null
        }
    ]
};

export function getMockSubscriptions(features) {
    if (features) {
        const modified = JSON.parse(JSON.stringify(mockSubscriptions));
        modified[customerSubscriptions][0][premiumFeatures] = features;
        return modified;
    }
    return mockSubscriptions;
}
